import { M8PartnerClientsOnMonth } from 'services/production/types';
import { createQueryString } from 'services/production/utils/createQueryString';
import { getM8PartnerURL } from 'services/production/utils/getM8URL';
import { HTTPResponseError } from 'utils/errors';
import { customFetch } from 'utils/http';

type Params = {
  page: number;
};

export const getPaidClientsForPrevMonth = async (
  params: Params
): Promise<M8PartnerClientsOnMonth[]> => {
  const fetchURL = getM8PartnerURL(
    `getPaidClientsForPrevMonth?${createQueryString(params)}`
  );

  const response = await customFetch(fetchURL);

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }

  return response.json();
};
